/**
 * @file 问卷文本类题目（开放式问题或带“其他”选项的选择题）详情
 * @author liudy
 * @see http://api.umucdn.cn/project/106/wiki
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

import { PollType } from '@umu/umu-types';

export interface IGetPollQuestionContentListInput {
    parent_id: number; // int 作业问卷ID
    parent_type: PollType; // int 1、保存作业多维度评价问卷模板 2、保存作业多维度评价问卷
    obj_id: number; // int 评价对象ID，比如学生提交作业的homework_id
    question_id: number; // int 题目id
    page?: number; // int 选填，默认1
    size?: number; // int 选填，默认10
}

export const getPollQuestionContentList = (
    data: IGetPollQuestionContentListInput,
): Promise<IListResponse<ISectionOptionResultContent>> => {
    return fetchData(Api.POLL_QUESTION_CONTENT_LIST, data).then((res: IListResponse<ISectionOptionResultContent>) => {
        return res;
    });
};

export const getPollQuestionContentListSync = fetchDataSync(getPollQuestionContentList);
